export const DateFormat = () => {

  Date.prototype.Format = function (fmt) {
    var o = {
      "M+": this.getMonth() + 1, //月份
      "d+": this.getDate(), //日
      "H+": this.getHours(), //小时
      "m+": this.getMinutes(), //分
      "s+": this.getSeconds(), //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
    }
    return fmt;
  }

  return Date;
}

export const isPhone = () => {
  if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) { //移动端
    return true
  }
  return false
}

export var PiB = 1024.0 * 1024.0 * 1024.0 * 1024.0 * 1024.0
export var TiB = 1024.0 * 1024.0 * 1024.0 * 1024.0
export var GiB = 1024.0 * 1024.0 * 1024.0
export var MiB = 1024.0 * 1024.0
export var KiB = 1024.0

export function switchStorageUnit2(storage){
  if(storage === null)
    return '--';
  let num = 0
  if(storage/PiB > 1){
    num = (storage/PiB).toFixed(2)
    return num + ' PiB'
  }
  if(storage/TiB > 1){
    num = (storage/TiB).toFixed(2)
    return num + ' TiB'
  }

  if(storage/GiB > 1){
    num = (storage/GiB).toFixed(2)
    return num + ' GiB'
  }

  if(storage/MiB > 1){
    num = (storage/MiB).toFixed(2)
    return num + ' MiB'
  }

  if(storage/KiB > 1){
    num = (storage/KiB).toFixed(2)
    return num + ' KiB'
  }

  return storage + ' Byte'
}